import Vue from 'vue'
import Vuex from 'vuex'
import * as consts from '../data/base/consts'

import mutations from './mutations'
import actions from './actions'
import BaseStore from './global/base'
import SettingStore from './global/setting'
import InformStore from './global/inform'
import MiniFateFortuneStore from './plugins/minifatefortune'
import AllRecordStore from './plugins/allrecord'
import RecordLetterStore from './plugins/recordletter'
import ChooseRecordStore from './plugins/chooserecord'
import CalendarStore from './plugins/calendar'
import GroupStore from './modules/group'
import LabelStore from './modules/label'
import CollateStore from './modules/collate'
import DiagramStore from './modules/diagram'
import RecordStore from './modules/record'
import SearchStore from './modules/search'
import DetailStore from './modules/detail'
import EditStore from './modules/edit'
import CommentStore from './modules/comment'
import OtherCommentStore from './modules/othercomment'
import DiscussStore from './modules/discuss'
import ShareStore from './modules/share'
import OtherShareStore from './modules/othershare'
import EmbeddedStore from './modules/embedded'
import DonateStore from './modules/donate'
import ReminderStore from './modules/reminder'
import ReportStore from './modules/report'
import FamousPediaStore from './modules/famouspedia'
import FamousPediaCommentStore from './modules/famouspediacomment'
import ContrastStore from './modules/contrast'
import CourseStore from './modules/course'
import PayStore from './modules/pay'
import UserStore from './modules/user'
import ActivityStore from './modules/activity'
import StrongStore from './modules/strong'
import YearStore from './modules/year'
import MarriageStore from './modules/marriage'
import DressStore from './modules/dress'

Vue.use(Vuex);

// 定义一些存在状态里的数据变量
const state = {
    public: {
        curPath: ''
    },
    platform: 0,
    userUid: 0,
    userData: {},
    showAuthRemind: false,
    loginData: {
        havePwd: 0,
        newMobile: '',
        lockCode: false,
        lockTime: consts.CONST_GET_CODE_TIME,
        lockTimeFunc: null
    },
    timeInputData: {
        "unknownTime": false,
        "isLunar": false,
        "year": '', 
        "month": '', 
        "day": '', 
        "hour": '', 
        "minute": ''
    },
    timeCurrent: true,
    shareTimes: 0,
    import: { showPopup: false },
    editChangeBirthday: false,
    gotUserTypeData: false,
    gotConfigJsonData: false,
    configYiJiJsonData: {},
    bannerList: [],
    homeFamousPediaList: [],
    homeCourseList: [],
    homeDiscussList: [],
    homeEbookList: [],
    homeArticleList: [],
    homePageDataTime: 0 // 首页数据的时间戳,用于判断是否需要重新获取
}

export default new Vuex.Store({
    modules: {
        base: BaseStore,
        setting: SettingStore,
        inform: InformStore,
        group: GroupStore,
        label: LabelStore,
        collate: CollateStore,
        diagram: DiagramStore,
        record: RecordStore,
        allrecord: AllRecordStore,
        recordletter: RecordLetterStore,
        chooserecord: ChooseRecordStore,
        calendar: CalendarStore,
        search: SearchStore,
        detail: DetailStore,
        edit: EditStore,
        share: ShareStore,
        othershare: OtherShareStore,
        comment: CommentStore,
        othercomment: OtherCommentStore,
        discuss: DiscussStore,
        minifatefortune: MiniFateFortuneStore,
        embedded: EmbeddedStore,
        donate: DonateStore,
        reminder: ReminderStore,
        report: ReportStore,
        famouspedia: FamousPediaStore,
        famouspediacomment: FamousPediaCommentStore,
        contrast: ContrastStore,
        course: CourseStore,
        pay: PayStore,
        user: UserStore,
        activity: ActivityStore,
        strong: StrongStore,
        year: YearStore,
        marriage: MarriageStore,
        dress: DressStore
    },
    state,
    getters: {
        configYiJiJsonData() {
            return state.configYiJiJsonData
        },
        groupData() {
            return state.group.groupData
        },
        commentAllSelectedList() {
            var resultData = state.famouspediacomment.commentAllSelectedList.sort((a, b) => {return state.famouspediacomment.commentAllSort == 1 ? b.time - a.time : a.time - b.time});
            return resultData;
        },
        commentAllMainList() {
            var resultData = state.famouspediacomment.commentAllMainList.sort((a, b) => {return state.famouspediacomment.commentAllSort == 1 ? b.time - a.time : a.time - b.time});
            return resultData;
        }
    },
    mutations, 
    actions
})